// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3cpZh","file":"styles_file__2977Y"};